import React, { useState, useEffect } from "react";
import {
  defineRecommendationType,
  definePluralOrSingular,
  fetchInsights,
  fetchConsiderations,
  checkRecData,
} from "./Recommendations";

const BoostAcademics = ({
  selectedRecommendationTab,
  emotionPercents,
  state,
}) => {
  // Define required state variables
  const [insights, setInsights] = useState("");
  const [recommendationType, setRecommendationType] = useState("");
  const [applicableEmotion, setApplicableEmotion] = useState("");
  const [pluralOrSingular, setPluralOrSingular] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [considerations, setConsiderations] = useState("");
  const [emotion_percent, setEmotionPercent] = useState("");

  const getHighestCurrentPercentEmotion = () => {
    emotionPercents.sort((a, b) => b.currentPercent - a.currentPercent);
    return emotionPercents[0];
  };

  const getHighestChange = () => {
    emotionPercents.sort((a, b) => b.change - a.change);
    return emotionPercents[0];
  };

  const getApplicableEmotions = (type, emotionPercents) => {
    if (type === "Frequency") {
      return getHighestCurrentPercentEmotion(emotionPercents);
    } else {
      return getHighestChange(emotionPercents);
    }
  };

  const processInsights = (insights, type, applicableEmotionDetails) => {
    try {
      let emotion_percent = "";
      if (type === "Frequency") {
        emotion_percent = applicableEmotionDetails.currentPercent;
      } else if (type === "Change") {
        emotion_percent = applicableEmotionDetails.change;
      }

      // Set the emotion percent
      setEmotionPercent(emotion_percent);

      // Replace the # with the emotion percent
      let original_insights = insights.insights;
      let new_insights = original_insights.replace("#", emotion_percent);

      // Replace the NAME with the chosen student name
      if (state.chosenStudent !== "All Students") {
        const actual_name =
          state.studentEmailToNameMap[state.chosenStudent] ||
          state.chosenStudent;
        new_insights = new_insights.replace("NAME", actual_name);
      }

      setInsights(new_insights);
    } catch (error) {
      setInsights("--");
    }
  };

  const getRecommendations = async () => {
    try {
      if (!checkRecData(emotionPercents)) {
        setInsights("--");
        setConsiderations("--");
        return;
      }

      // Set is loading to true
      setIsLoading(true);

      // Get all values synchronously
      const type = defineRecommendationType();
      const applicableEmotionDetails = getApplicableEmotions(
        type,
        emotionPercents
      );
      const emotion = applicableEmotionDetails.name;

      // Define weather plural or singular
      let isPlural = true;
      if (state.chosenStudent && state.chosenStudent != "All Students") {
        isPlural = false;
      }
      const plural_or_singular = definePluralOrSingular(isPlural);

      // Update states
      setRecommendationType(type);
      setApplicableEmotion(emotion);
      setPluralOrSingular(plural_or_singular);

      // Get and Process Insights
      const insightsResponse = await fetchInsights(
        emotion,
        type,
        plural_or_singular,
        selectedRecommendationTab
      );
      await processInsights(insightsResponse, type, applicableEmotionDetails);

      // Get considerations from the backend
      await fetchConsiderations(
        emotion,
        plural_or_singular,
        setConsiderations,
        selectedRecommendationTab
      );
    } catch (error) {
      setInsights("An error occurred while getting Insights/Considerations.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getRecommendations();
  }, [emotionPercents]);

  return (
    <div className="flex flex-col gap-4">
      <div className="border-l-4 border-[#2D3748] pl-4">
        <h5 className="text-[12px] text-[#2D3748] font-semibold mb-2">DATA</h5>
        <p className="text-400 text-[16px] text-normal">{insights}</p>
      </div>

      <div className="border-l-4 border-[#005BE2] pl-4">
        <h5 className="text-[12px] text-[#005BE2] font-semibold mb-2">
          CONSIDER
        </h5>
        <div className="relative group">
          <p className="text-400 text-[16px] font-normal line-clamp-4">
            {considerations}
          </p>
          <div className="absolute top-0 left-0 hidden group-hover:block bg-white text-[16px] text-400 border border-gray-200 rounded-md shadow-lg p-3 z-20 w-full">
            {considerations}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BoostAcademics;
